<ng-container *ngIf="!(isPartOfArNavigation$  | async)">
    <div class="alert alert-danger">{{ 'aumico_reports_page_is_not_part_of_ar_navigation' | i18next }}</div>
</ng-container>
<ng-container *ngIf="(isPartOfArNavigation$  | async)" content>
    <div class="container-wrapper">
        <div *ngIf="currentAnnualReport != null" class="complementary-reports-page">
            <aumico-annualReport-complementary-reports-page
                [complementaryReports]="currentComplementaryReports"
                [organizationHasCpmmActive]="organizationHasCpmmActive"
                (onComplementaryReportsChanged)="onComplementaryReportsChanged($event)"
                (complementaryReportsStatus)="onFormsStatusesChanged($event)"
                (printComplementaryReportRequested)="onPrintComplementaryReportRequested($event)"
            ></aumico-annualReport-complementary-reports-page>
        </div>
    </div>

    <div *ngIf=" currentAnnualReport == null" class="alert alert-danger">
        {{ localizationKeys.aumico_reports_required_data_not_completed | i18next }}
    </div>

    <div style="display: none" *ngIf="appropriationOfProfitSection && snapshotStyleOptions">
        <div #aopSnapshot id="aopSnapshot" class="aop-snapshot">
            <aumico-annualReport-appropriation-of-profit-german-display-component
                *ngIf="isGermanBusinessModel"
                [stylePreferenceOptions]="snapshotStyleOptions"
                [appropriationOfProfitSection]="appropriationOfProfitSection"
                [noPreviousData]="snapshotNoPreviousData"
                [isSnapshot]="true"
            >
            </aumico-annualReport-appropriation-of-profit-german-display-component>
            <aumico-annualReport-appropriation-of-profit-swiss-display-component
                *ngIf="!isGermanBusinessModel"
                [stylePreferenceOptions]="snapshotStyleOptions"
                [appropriationOfProfitSection]="appropriationOfProfitSection"
                [noPreviousData]="snapshotNoPreviousData"
                [isSnapshot]="true"
            >
            </aumico-annualReport-appropriation-of-profit-swiss-display-component>
        </div>
    </div>

    <div style="display: none" *ngIf="appropriationOfProfitSection && snapshotStyleOptions">
        <div #aopSnapshotCurrentYear id="aopSnapshotCurrentYear" class="aop-snapshot-current-year">
            <aumico-annualReport-appropriation-of-profit-german-display-component
                *ngIf="isGermanBusinessModel"
                [stylePreferenceOptions]="snapshotStyleOptions"
                [appropriationOfProfitSection]="appropriationOfProfitSection"
                [noPreviousData]="true"
                [isSnapshot]="true"
            >
            </aumico-annualReport-appropriation-of-profit-german-display-component>
            <aumico-annualReport-appropriation-of-profit-swiss-display-component
                *ngIf="!isGermanBusinessModel"
                [stylePreferenceOptions]="snapshotStyleOptions"
                [appropriationOfProfitSection]="appropriationOfProfitSection"
                [noPreviousData]="true"
                [isSnapshot]="true"
            >
            </aumico-annualReport-appropriation-of-profit-swiss-display-component>
        </div>
    </div>
</ng-container>
<ng-template #footerTemplate>
    <aum-action-bar-pure
        [extraActionButtons]="footerExtraButtonActions"
        nextButtonPrefixText="'{{nextStepPrefix | i18next}}'"
        nextButtonText="{{nextStepLabel | i18next}}"
        nextButtonRouterLink="../{{nextStepPath}}"
        [nextButtonAction]="proceedButtonClicked"
        [nextButtonDisabled]="disableProceedButton"
        backButtonPrefixText="{{previousStepPrefix | i18next}}"
        backButtonText="{{previousStepLabel | i18next}}"
        backButtonRouterLink="../{{previousStepPath}}"
        [backButtonIcon]="previousStepIcon"
    ></aum-action-bar-pure>
</ng-template>
